export const LOADING_VERBS: string[] = [
  'Discombobulating...',
  'Thinking...',
  'Statsifying...',
  'Reticulating splines...',
  'Interrogating the squirrels...',
  'Crunching ancient emails...',
  'Quantifying procrastination...',
  'Defragmenting hot takes...',
  'Polishing the acorns...',
  'Reverse-engineering sarcasm...',
  'Extrapolating shenanigans...',
  'Bamboozling the database...',
  'Synthesizing banter...',
  'Measuring keyboard mashing...',
  'Calibrating snark levels...',
  'combobulating the uncombobulated...',
  'Spelunking through thread trees...',
  'Distilling pure nonsense...',
  'Triangulating reply velocity...',
  'Unspooling decades of lore...',
  'Counting passive-aggressive punctuation...',
  'Fermenting artisanal metrics...',
  'Summoning the ghost of dead threads...',
  'Cross-referencing inside jokes...',
  'Transmuting procrastination into charts...',
  'Hyper-optimizing squirrel telemetry...',
  'Deciphering 3am typos...',
  'Herding digital rodents...',
  'Percolating questionable opinions...',
  'Re-indexing the hivemind...',
  'Weighing the gravitas of one-word replies...',
  'Buffering existential dread...',
  'Untangling reply-all catastrophes...',
  'Sifting through ancient flamewars...',
  'Calculating the half-life of memes...',
  'Consulting the Oracle of Cult HQ...',
  'Lubricating the hamster wheels...',
  'Normalizing abnormal behavior...',
  'Extracting weapons-grade statistics...',
  'Harmonizing chaotic energy...',
  'Simulating 1,000 monkeys on keyboards...',
  'Chronologically sorting bad decisions...',
  'Scanning for unhinged subject lines...',
  'Inflating self-importance metrics...',
  'Deconstructing reply chains...',
  'Fluxing the social capacitor...',
  'Wrangling rogue timestamps...',
  'Agitating the algorithm...',
  'Marinating the metadata...',
  'Overcomplicating simple addition...',
  'Flibbertigibbeting at scale...',
  'Gerrymandering the leaderboards...',
  'Laundering dirty word counts...',
  'Catapulting packets across the void...',
  'Dividing by zero (carefully)...',
  'Reading between the quoted lines...',
  'Bribing the query planner...',
  'Dusting off 2002 archives...',
  'Warming up the Hot Take Reactor...',
  'Electroplating the trophies...',
  'Caffeinating the worker threads...',
  'Rummaging through attachment drawers...',
  'Measuring the density of dad jokes...',
  'Applying quantum uncertainty to post counts...',
  'Shuffling the deck of destiny...',
  'Compiling a symphony of shitposts...',
  'Auditing midnight ramblings...',
  'Negotiating with stubborn SQL joins...',
  'Converting hot air into bar graphs...',
  'Tickling the服务器 hamsters...',
  'Evaluating thermodynamic thread decay...',
  'Magnifying micro-aggressions...',
  'Uncovering forgotten tangents...',
  'Stirring the primordial soup of data...',
  'Juggling floating-point squirrel nuts...',
  'Indexing unsolicited advice...',
  'Calculating your exact rank in the cult...',
  'Demagnetizing the reply magnets...',
  'Waking up the night owls...',
  ' Interrogating the early birds...',
  'Measuring ham-to-email ratios...',
  'Counting every single swear word...',
  'Reconstructing the timeline...',
  'Polishing the crystal ball...',
  'Squeezing insights from stone...',
  'Unleashing the kraken of analytics...',
  'Tuning the resonance of hot gossip...',
  'Sorting acorns by emotional weight...',
  'Charting uncharted conversational waters...',
  'Reviving dead threads for science...',
  'Decoding cryptic one-liners...',
  'Spooling the hyperdrive...',
  'Engaging ludicrous speed...',
  'Distorting reality fields...',
  'Choreographing the data dance...',
  'Baking fresh pie charts...',
  'Garnishing tables with artisanal pixels...',
  'Whispering sweet nothings to MySQL...',
  'Sweeping dust out of the server rack...',
  'Untying Gordian thread knots...',
  'Alchemizing emails into pure gold...',
  'Summoning statistical anomalies...',
  'Balancing the cosmic ledger...',
  'Validating questionable life choices...',
  'Vaporizing redundant whitespace...',
  'Spinning up the drama centrifuge...',
  'Aligning the celestial squirrels...',
  'Computing the meaning of life (it is 42)...',
  'Almost done pretending to work hard...',
];

/**
 * Returns a shuffled copy of LOADING_VERBS using Fisher-Yates.
 */
export const getShuffledVerbs = (): string[] => {
  const copy = [...LOADING_VERBS];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
};
